import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useQuery } from "@tanstack/react-query";
import { INotificationCenterResponse } from "./notificationCenterApi.types";
import { ICommonServiceProps } from "@api/types/globalService.types";

const useGetAllNotificatioServices = ({
  filters,
  enableQuery = true,
  page = "1",
  per_page = "15",
}: ICommonServiceProps) => {
  const allNotificationService = useQuery<INotificationCenterResponse>({
    queryKey: [
      ...CACHE_KEYS.NOTIFICATION_CENTER,
      filters,
      page,
      per_page,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.NOTIFICATION_CENTER,
        searchParams: {
          ...filters,
          page: page,
          per_page: per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allNotificationService },
  };
};

export default useGetAllNotificatioServices;
